import 'element-ui/lib/theme-chalk/index.css'
import { Card,Tag,Upload,Button, Message,Menu,MenuItem,Image,Breadcrumb,BreadcrumbItem,Form,FormItem,DatePicker,Select,Option,Table,TableColumn, Input,Dialog, Pagination, Row, Col, Checkbox,MessageBox, DropdownMenu, DropdownItem, Dropdown, Submenu, MenuItemGroup,Aside, Tabs, TabPane, Radio, RadioGroup,Tooltip,CollapseTransition,Timeline,TimelineItem,InputNumber,Steps,Step,Switch,Divider,Icon} from 'element-ui'

let Components = [
    Card,
    Upload,
    Button,
    Menu,
    MenuItem,
    Image,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    DatePicker,
    Select,
    Option,
    Table,
    TableColumn,
    Input,
    Dialog,
    Pagination,
    Row,
    Col,
    Checkbox,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Submenu,
    MenuItemGroup,
    Aside,
    Tabs,
    TabPane,
    Radio,
    RadioGroup,
    Tooltip,
    CollapseTransition,
    Timeline,
    TimelineItem,
    InputNumber,
    Steps,
    Step,
    Switch,
    Divider,
    Icon,
    Tag
]

export default function getElementUI(app){
    Components.forEach(item => {
        // return app.use(item)
        return app.component(item.name,item)
    })
    app.prototype.$message = Message
    app.prototype.$confirm = MessageBox.confirm
    app.prototype.$alert = MessageBox.alert
}
